module.exports = __webpack_public_path__ + "img/1-2.6b23c244.png";